import React, { createContext, ReactNode, useContext, useState } from "react";

type AuthState = {
  isLoggedIn: boolean;
  setLoggedIn: (loggedIn: boolean) => void;
};

/**
 * The login store context.
 */
const AuthContext = createContext<AuthState | undefined>(undefined);

/**
 * The login store provider.
 */
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isLoggedIn, setLoggedIn] = useState(!!(window as any).loggedIn);

  return <AuthContext.Provider value={{ isLoggedIn, setLoggedIn }}>{children}</AuthContext.Provider>;
};

/**
 * Hook to access the login state.
 */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("Auth context is not provided.");
  }
  return context;
};
